
import styles from './style.module.css';
import { getMainInfo } from "store/HomeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAbouUsPageData } from "store/MainSlice";
import React, { useEffect } from "react";
import langData from "../../lang/data";
import MainBanner from "./components/MainBanner";
import VideoSection from "./components/VideoSection";
import BrandCarousel from "./components/BrandCarusel";
import Advantages from "./components/Advantages";
import Members from "./components/Members";
import News from "./components/News";
import Branches from "./components/Branches";
import BankSection from "./components/BankSection";

function NewAboutUs() {

    const dispatch = useDispatch();

    const { currentLanguage, aboutUsPageData } = useSelector(({ main }) => main);

    console.log(aboutUsPageData)

    useEffect(() => {
        dispatch(getMainInfo());
        dispatch(getAbouUsPageData());
    }, [dispatch]);

    return (
        <div className={styles.container}>
            <MainBanner
                banner = { aboutUsPageData?.baner }
            />
            <VideoSection
                data = {aboutUsPageData?.about_us["block_1_" + currentLanguage]}
            />
            <BrandCarousel
                brands={aboutUsPageData?.brands}
                top={50}
            />
            <BrandCarousel
                brands={aboutUsPageData?.brands}
            />
            <div
                className = {styles.description_box}
                dangerouslySetInnerHTML = {{
                    __html: aboutUsPageData?.about_us["block_4_" + currentLanguage],
                }}
            />
            <Advantages/>
            <Members
                image = {process.env.REACT_APP_STORAGE_URL + aboutUsPageData?.about_us["block_6_image_" + currentLanguage]}
                title = {aboutUsPageData?.about_us["block_6_title_" + currentLanguage]}
            />
            <News
                news = { aboutUsPageData?.news || [] }
            />
            <Branches/>
            <BankSection/>
            {/*<button className={styles.view_all_button}>*/}
            {/*    { langData.buttons.view_all[currentLanguage] }*/}
            {/*</button>*/}
        </div>
    )
}

export default NewAboutUs